import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useEffect, useRef, useState } from 'react'

export default function UsersRoleTooltipMobile() {
  const [isOpen, setIsOpen] = useState(false)
  const tooltipRef = useRef<HTMLDivElement>(null)

  const handleToggle = () => {
    setIsOpen(!isOpen)
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      tooltipRef.current &&
      !tooltipRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <Tooltip open={isOpen}>
      <div ref={tooltipRef}>
        <TooltipTrigger
          onClick={handleToggle}
          className="cursor-pointer md:cursor-default"
        >
          <div className="flex flex-row gap-1 items-center">
            <p className="text-sm text-[#202224] font-black">Role</p>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.6">
                <path
                  d="M14.6667 8.00004C14.6667 9.76815 13.9643 11.4638 12.7141 12.7141C11.4638 13.9643 9.76815 14.6667 8.00004 14.6667C6.23193 14.6667 4.53624 13.9643 3.286 12.7141C2.03575 11.4638 1.33337 9.76815 1.33337 8.00004C1.33337 6.23193 2.03575 4.53624 3.286 3.286C4.53624 2.03575 6.23193 1.33337 8.00004 1.33337C9.76815 1.33337 11.4638 2.03575 12.7141 3.286C13.9643 4.53624 14.6667 6.23193 14.6667 8.00004ZM7.33337 8.66671V10.6667C7.33337 10.8435 7.40361 11.0131 7.52864 11.1381C7.65366 11.2631 7.82323 11.3334 8.00004 11.3334C8.17685 11.3334 8.34642 11.2631 8.47145 11.1381C8.59647 11.0131 8.66671 10.8435 8.66671 10.6667V8.66671C8.66671 8.4899 8.59647 8.32033 8.47145 8.1953C8.34642 8.07028 8.17685 8.00004 8.00004 8.00004C7.82323 8.00004 7.65366 8.07028 7.52864 8.1953C7.40361 8.32033 7.33337 8.4899 7.33337 8.66671ZM8.00004 5.00004C7.73482 5.00004 7.48047 5.1054 7.29293 5.29293C7.1054 5.48047 7.00004 5.73482 7.00004 6.00004C7.00004 6.26526 7.1054 6.51961 7.29293 6.70715C7.48047 6.89468 7.73482 7.00004 8.00004 7.00004C8.26526 7.00004 8.51961 6.89468 8.70715 6.70715C8.89468 6.51961 9.00004 6.26526 9.00004 6.00004C9.00004 5.73482 8.89468 5.48047 8.70715 5.29293C8.51961 5.1054 8.26526 5.00004 8.00004 5.00004Z"
                  fill="black"
                />
              </g>
            </svg>
          </div>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          className="max-w-[220px] -mt-2 block md:hidden 
              data-[state=closed]:hidden data-[state=open]:block 
              md:data-[state=closed]:block"
        >
          Members with Admin privileges have access to account level features
          setup for the company (including user management).
        </TooltipContent>
      </div>
    </Tooltip>
  )
}
